<div
  class="layout-menu-btn"
  (click)="openLayoutMenu()"
  statistic
  [statisticElementName]="'Chart layout menu open menu'"
  [ivLiveHint]="locale.selectLayout"
  ivLiveHintPosition="top-right"
>
  <img src="iv-live/assets/icons/chart-service/layout-menu/{{selectedLayout?.name}}.svg" alt="svg">
</div>

<div
  class="layout-menu-list-items"
  *ngIf="isLayoutMenuOpened"
  [disabled]="disabled"
  ngDefaultControl
  [(ngModel)]="selectedLayout"
>
  <div
    class="layout-menu-item"
    *ngFor="let item of layoutsList"
  >
    <span class="layout-menu-item__charts-amount">{{item.cardsAmount}}</span>

    <div
      class="layout-menu-item__icon"
      [class.layout-menu-item__icon-selected]="layout.name === selectedLayout?.name"
      *ngFor="let layout of item.layoutEntity"
      (click)="selectLayout(layout)"
      statistic
      [statisticElementName]="'Chart Layout menu select layout'"
    >
      <img src="iv-live/assets/icons/chart-service/layout-menu/{{layout.name}}.svg" alt="svg"/>
    </div>

    <div class="layout-menu-item__divider"></div>
  </div>
</div>

